import { type FC } from 'react';

import Text from 'components/_core/Text';

import GuidanceBaseHelp from './Base/GuidanceBaseHelp';
import locales from './locales';

/**
 * Help-like guidance to describe the different legalforms
 */
const GuidanceShineStartSociety: FC = () => {
  const loc = locales.shineStartSociety;

  return (
    <GuidanceBaseHelp title={loc.title}>
      <Text color="inherit" fontSize="inherit">
        {loc.content}
      </Text>
    </GuidanceBaseHelp>
  );
};

export default GuidanceShineStartSociety;
